import { AWARD_PROGRESS } from "../../../../common/enums/award-progress-codes";
import { QUALIFICATION_STATUS } from "../../../../common/enums/incentive-enums";
import type { TrendEnum } from "../../../../common/leaf/LeafTrendIndicator/LeafTrendIndicator";

export const parseStatus = (status: string) => {
  switch (status) {
    case QUALIFICATION_STATUS.QUALIFIED:
    case QUALIFICATION_STATUS.MANUALLY_APPROVED:
    case QUALIFICATION_STATUS.AUTOMATICALLY_APPROVED:
    case QUALIFICATION_STATUS.MANUALLY_QUALIFIED:
    case QUALIFICATION_STATUS.ACHIEVED:
      return AWARD_PROGRESS.ACHIEVED;
    case QUALIFICATION_STATUS.TRACKING:
    case QUALIFICATION_STATUS.ELIGIBLE:
    case QUALIFICATION_STATUS.ON_TRACK:
      return AWARD_PROGRESS.TRACKING;
    case QUALIFICATION_STATUS.DENIED:
    case QUALIFICATION_STATUS.NOT_ELIGIBLE:
    case QUALIFICATION_STATUS.REWORK_DISQUALIFIED:
    case QUALIFICATION_STATUS.REWORK_DENIED:
      return AWARD_PROGRESS.NOT_ELIGIBLE;
    case QUALIFICATION_STATUS.HELD:
      return AWARD_PROGRESS.ON_HOLD;
    default:
      return AWARD_PROGRESS.NOT_TRACKING;
  }
};

export const parseBadgeStatus = (status: string) => {
  switch (status) {
    case QUALIFICATION_STATUS.QUALIFIED:
      return AWARD_PROGRESS.ACHIEVED;
    case QUALIFICATION_STATUS.NOT_TRACKING:
    case QUALIFICATION_STATUS.NOT_QUALIFIED:
      return AWARD_PROGRESS.NOT_TRACKING;
    default:
      return AWARD_PROGRESS.TRACKING;
  }
};

export const spreadTrend = (trendData?: { trend: TrendEnum; difference: number }) => {
  if (!trendData) return {};
  return {
    trend: trendData.trend,
    number: trendData.difference,
  };
};
